// Session-scoped sibling of storageService. Backed by sessionStorage so the
// values die when the browser tab/session ends.
//
// Used for the post-login "resume where I was" breadcrumb. We deliberately do
// NOT want that to survive logout, browser restarts, or a fresh login days
// later: a persistent (localStorage) breadcrumb dropped users onto pages from
// a prior session (warm-up jobs, CCCREM, the classic app) on a deliberate
// login. Scoping it to the current browser session means a fresh login lands
// on home, while a same-session refresh or re-login still resumes cleanly.

const sessionStorageService = {
  setItem(key: string, value: unknown): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("Error saving to sessionStorage", error);
    }
  },

  getItem<T>(key: string): T | null {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? (JSON.parse(stored) as T) : null;
    } catch (error) {
      console.error("Error reading from sessionStorage", error);
      return null;
    }
  },

  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing from sessionStorage", error);
    }
  },
};

export default sessionStorageService;
